/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import Tag from 'Administrator/MediaLibrary/EditFile/Tag';

class Tags extends React.Component{
  constructor(props){
    super(props);
    this.tags = [];
    props.file.fetch({
      success: () => {
        this.tags = props.file.get('tags').map((tag, i) => {
          return <Tag key={i} tag={tag} style={{margin: '5px'}}/>;
        });
        this.forceUpdate();
      }
    });
  }

  render(){
    return this.tags.length > 0 ? <span>
                  <h3>Tags</h3>
                  <div>
                    {this.tags}
                  </div>
                </span> : null;
  }
}

export default Tags;
